// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".member-statistic-box[data-v-4087e6a7]  .statistic-list-box {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 14px;\n}\n[data-v-4087e6a7] .el-form-item {\n  margin-bottom: 0 !important;\n}", ""]);
// Exports
module.exports = exports;
